import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { format } from "date-fns";
import { getErrorsMessage } from '../utils.js'; 
import { LangContext } from "../LangContext.jsx";  
class ClientDossierTypesPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            data: null,
            targets:[],
            permissions:[], 
        };
    }
    componentDidMount() { 
        this.getData()
        this.state.targets = this.props.permissions.targets
        this.state.permissions = this.props.permissions
        let tab = this.props.permissions.targets[0] 
        if(tab == 3){
            $('#te_empleados').addClass('active')
            $('#pl_empleados').addClass('active')
        }
        if(tab == 1){
         
            $('#te_clientes').addClass('active')
            $('#pl_clientes').addClass('active')
        }
        if(tab == 2){
            $('#te_proveedores').addClass('active')
            $('#pl_proveedores').addClass('active')
        }
        if(tab == 4){ 
            $('#te_propios').addClass('active')
            $('#pl_propios').addClass('active')
        }
    }

    async getData(){
        const res = await axios.get('/api/clients/statistics/') 
        res.data.dossiersProviders.forEach(function(row, i){
            if(row.title == "Nacional") row.color = 'danger';
            if(row.title == "Internacional") row.color = 'success';
            if(row.title == "Especiales") row.color = 'info';
            if(row.title == "Otros") row.color = 'warning';

            row.percentage = (row.total*100) / res.data.totalDossierProviders;

            if(res.data.dossiersProviders.length-1 === i){
                row.percentage += 4; // plus 4%
            }
        });

        res.data.dossiersEmployees.forEach(function(row, i){
            if(row.title == "Nacional") row.color = 'danger';
            if(row.title == "Internacional") row.color = 'success';
            if(row.title == "Especiales") row.color = 'info';
            if(row.title == "Otros") row.color = 'warning';

            row.percentage = ((row.total * 100) / res.data.totalDossierEmployees).toFixed(2);

            if(res.data.dossiersEmployees.length-1 === i){
                //row.percentage += 4; // plus 4%
            }
        });

        res.data.dossiersClients.forEach(function(row, i){
            if(row.title == "Nacional") row.color = 'danger';
            if(row.title == "Internacional") row.color = 'success';
            if(row.title == "Especiales") row.color = 'info';
            if(row.title == "Otros") row.color = 'warning';
            row.percentage = ((row.total * 100) / res.data.totalDossierClients).toFixed(2);
            if(res.data.dossiersClients.length-1 === i){
                //row.percentage += 4; // plus 4%
            }
        }); 
        res.data.personalDossiers.forEach(function(row, i){ 
            if(row.title == "Nacional") row.color = 'danger';
            if(row.title == "Internacional") row.color = 'success';
            if(row.title == "Especiales") row.color = 'info';
            if(row.title == "Propio") row.color = 'warning';

            row.percentage = ((row.total * 100) / res.data.totalDossierPersonal).toFixed(2);

            if(res.data.dossiersClients.length-1 === i){
                //row.percentage += 4; // plus 4%
            }
        });
        this.setState({data: res.data})
    }

    render() { 
        const { lang } = this.context; 
        return (<div>
            <div className="row mb-2">
                <div className="col-4">
                    <h3 className="card-title m-0">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75"> 
                            {lang.get('messages.tipos_de_expedientes')}
                        </span> 
                    </h3>
                </div>
                <div className="col-8">
                    <ul className="nav nav-pills nav-pills-sm nav-dark">
                        { this.props.permissions.targets.includes(2) &&
                        <li className="nav-item ml-0">
                            <a id="pl_proveedores" className="nav-link py-2 px-4 font-weight-bolder font-size-sm" data-toggle="tab" href="#te_proveedores">
                                {lang.get('messages.proveedores')}
                            </a>
                        </li>
                        }
                        { this.props.permissions.targets.includes(3) &&
                        <li className="nav-item ml-0">
                            <a id="pl_empleados" className="nav-link py-2 px-4 font-weight-bolder  font-size-sm" data-toggle="tab" href="#te_empleados">
                                {lang.get('messages.empleados')}
                            </a>
                        </li>
                        }
                        { this.props.permissions.targets.includes(1) &&
                        <li className="nav-item ml-0">
                            <a id="pl_clientes" className="nav-link py-2 px-4 font-weight-bolder  font-size-sm" data-toggle="tab" href="#te_clientes">
                                {lang.get('messages.clientes')}
                            </a>
                        </li>
                        }
                        { this.props.permissions.targets.includes(4) &&
                        <li className="nav-item ml-0">
                            <a id="pl_propios" className="nav-link py-2 px-4 font-weight-bolder  font-size-sm" data-toggle="tab" href="#te_propios">
                                {lang.get('messages.propios')}
                            </a>
                        </li>
                        }
                    </ul>
                </div>
            </div>

            <div className="tab-content">
                <div className="tab-pane fade show " id="te_proveedores" role="tabpanel" aria-labelledby="te_proveedores">
                    <div className="row">
                        <div className="col-8">
                            <div className="flex-row-fluid pt-8">
                                <span className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data == null ? 0 : this.state.data.totalDossierProviders } {lang.get('messages.de')} { this.state.data == null ? 0 : this.state.data.total }
                                    <span className="text-muted font-size-h5 font-weight-bold pl-2">
                                        {lang.get('messages.expedientes_de_proveedores')}
                                    </span> 
                                </span>
                                <div className="progress mt-3">
                                    { this.state.data?.dossiersProviders.map((d, i) => {
                                        return  <div    key={i}
                                                        className={"progress-bar _rounded _mr-n3  bg-"+d.color+" zindex-"+i}
                                                        role="progressbar"
                                                        style={{ width: d.percentage+"%" }}
                                                        aria-valuenow="15"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                ></div>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            { this.state.data?.dossiersProviders.map((d, i) => {
                                return  <div className="mt-4" key={i}>
                                            <a style={{ width: '19px', height: '19px'}} href="#" className={ "btn btn-xs btn-icon mr-2 btn-" + d.color }>&nbsp;</a>
                                            <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg">{d.title}</span>
                                        </div>
                            })}
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade show" id="te_empleados" role="tabpanel" aria-labelledby="te_empleados">
                    <div className="row">
                        <div className="col-8">
                            <div className="flex-row-fluid pt-8">
                                <span className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data == null ? 0 : this.state.data.totalDossierEmployees } {lang.get('messages.de')} { this.state.data == null ? 0 : this.state.data.total }
                                    <span className="text-muted font-size-h5 font-weight-bold pl-2">
                                        {lang.get('messages.expedientes_de_empleados')}  
                                    </span> 
                                </span>
                                <div className="progress mt-3">
                                    { this.state.data?.dossiersEmployees.map((d, i) => {
                                        return  <div    key={i}
                                                        className={"progress-bar rounded mr-n3 bg-"+d.color+" zindex-"+i}
                                                        role="progressbar"
                                                        style={{ width: d.percentage+"%" }}
                                                        aria-valuenow="15"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                ></div>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-4">

                            { this.state.data?.dossiersEmployees.map((d, i) => {
                                return  <div className="mt-4" key={i}>
                                            <a style={{ width: '19px', height: '19px'}} href="#" className={ "btn btn-xs btn-icon mr-2 btn-" + d.color }>&nbsp;</a>
                                            <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg">{d.title}</span>
                                        </div>
                            })}

                        </div>
                    </div>

                </div>
                <div className="tab-pane fade show" id="te_clientes" role="tabpanel" aria-labelledby="te_clientes">
                    <div className="row">
                        <div className="col-8">
                            <div className="flex-row-fluid pt-8">
                                <span className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data == null ? 0 : this.state.data.totalDossierClients } {lang.get('messages.de')} { this.state.data == null ? 0 : this.state.data.total }
                                    <span className="text-muted font-size-h5 font-weight-bold pl-2">{lang.get('messages.expedientes_de_cliente')}</span>
                                </span>
                                <div className="progress mt-3">
                                    { this.state.data?.dossiersClients.map((d, i) => {
                                        return  <div    key={i}
                                                        className={"progress-bar rounded mr-n3 bg-"+d.color+" zindex-"+i}
                                                        role="progressbar"
                                                        style={{ width: d.percentage+"%" }}
                                                        aria-valuenow="15"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                ></div>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            { this.state.data?.dossiersClients.map((d, i) => {
                                return  <div className="mt-4" key={i}>
                                            <a style={{ width: '19px', height: '19px'}} href="#" className={ "btn btn-xs btn-icon mr-2 btn-" + d.color }>&nbsp;</a>
                                            <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg">{d.title}</span>
                                        </div>
                            })}
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade show" id="te_propios" role="tabpanel" aria-labelledby="te_clientes">
                    <div className="row">
                        <div className="col-8">
                            <div className="flex-row-fluid pt-8">
                                <span className="text-dark-75 font-weight-bolder display4">
                                    { this.state.data == null ? 0 : this.state.data.totalDossierPersonal } {lang.get('messages.de')} { this.state.data == null ? 0 : this.state.data.total }
                                    <span className="text-muted font-size-h5 font-weight-bold pl-2">{lang.get('messages.expedientes_propios')}</span>
                                </span>
                                <div className="progress mt-3">
                                    { this.state.data?.personalDossiers.map((d, i) => {
                                        return  <div    key={i}
                                                        className={"progress-bar rounded mr-n3 bg-"+d.color+" zindex-"+i}
                                                        role="progressbar"
                                                        style={{ width: d.percentage+"%" }}
                                                        aria-valuenow="15"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                ></div>
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-4"> 
                            { this.state.data?.personalDossiers.map((d, i) => {
                                return  <div className="mt-4" key={i}>
                                            <a style={{ width: '19px', height: '19px'}} href="#" className={ "btn btn-xs btn-icon mr-2 btn-" + d.color }>&nbsp;</a>
                                            <span className="text-dark-75 mb-1 font-weight-bolder font-size-lg">{d.title}</span>
                                        </div>
                            })}

                        </div>
                    </div>

                </div>
                { ( !this.props.permissions.targets.includes(1)
                || !this.props.permissions.targets.includes(2)
                || !this.props.permissions.targets.includes(3)
                ) &&
                <p className="text-muted mt-3 font-weight-bold font-size-sm">
                    {lang.get('messages.los_numeros_mostrados_corresponden_a_los_totales_dados_de_alta_en_caso_de_que_no_puedas_ver_todos_es_por_falta_de_acceso')}
                    </p>
                }
            </div>

        </div>);
    }
}

export default ClientDossierTypesPanel;

if (document.getElementById('ClientDossierTypesPanel')) {
    ReactDOM.render(<ClientDossierTypesPanel />, document.getElementById('ClientDossierTypesPanel'));
}
